import { RewardCodeService } from './model/squareup/rewards/rewardCode/buyer_service';
import rpc from './rpc';

export default RewardCodeService.create(rpc());
